import { ClockIcon, ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { formatDateTimeLabel } from "../utils";

export default function EditionsPagination({
  showPagination,
  page,
  totalPages,
  visiblePageNumbers,
  lastSyncAt,
  onPrev,
  onNext,
  onGoToPage,
}) {
  return (
    <>
      {showPagination ? (
        <div className="flex items-center justify-between border-t border-gray-100 px-6 py-3">
          <div className="text-xs text-gray-500">Page {page}</div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              className="rounded border border-gray-300 px-2 py-1 text-xs text-gray-700 disabled:opacity-50"
              disabled={page <= 1}
              onClick={onPrev}
            >
              Prev
            </button>
            {visiblePageNumbers.map((pageNumber) => (
              <button
                key={pageNumber}
                type="button"
                className={`rounded border px-2 py-1 text-xs ${
                  page === pageNumber
                    ? "border-cyan-500 bg-cyan-500 text-white"
                    : "border-gray-300 text-gray-700"
                }`}
                onClick={() => onGoToPage(pageNumber)}
              >
                {pageNumber}
              </button>
            ))}
            <button
              type="button"
              className="rounded border border-gray-300 px-2 py-1 text-xs text-gray-700 disabled:opacity-50"
              disabled={page >= totalPages}
              onClick={onNext}
            >
              Next
            </button>
          </div>
        </div>
      ) : null}
      <div className="flex items-center justify-end gap-2 border-t border-gray-100 px-6 py-3 text-xs text-gray-500">
        <ClockIcon className="h-4 w-4" />
        Last sync: {formatDateTimeLabel(lastSyncAt)}
        <ExclamationCircleIcon className="ml-2 h-4 w-4 text-red-500" />
      </div>
    </>
  );
}
